export const CREATE_MESSAGE_PENDING = "CREATE_MESSAGE_PENDING";
export const CREATE_MESSAGE_SUCCESS = "CREATE_MESSAGE_SUCCESS";
export const CREATE_MESSAGE_ERROR = "CREATE_MESSAGE_ERROR";

export function createMessagePending() {
  return { type: CREATE_MESSAGE_PENDING }
}

export function createMessageSuccess(payload) {
  return { type: CREATE_MESSAGE_SUCCESS, payload }
}

export function createMessageError(error) {
  return { type: CREATE_MESSAGE_ERROR, error }
}
